import { TypingText } from "@workspace/ui/components/typing-text";
import { cn } from "@workspace/ui/lib/utils";

type BrandDescriptionProps = {
  onDescTypingComplete?: () => void;
  showBears?: boolean;
  skipAnimation?: boolean;
  isLandingPage?: boolean;
};

export function BrandDescription({
  onDescTypingComplete,
  showBears = true,
  skipAnimation = false,
  isLandingPage = false,
}: BrandDescriptionProps) {
  const textClass = cn(
    "text-base",
    isLandingPage ? "landing-text-secondary" : "text-muted-foreground"
  );

  const descriptionContent = skipAnimation ? (
    <p className={textClass}>
      Nearly instant image editing & creation from your favorite models,
      straight from your favorite messenger apps.
    </p>
  ) : (
    <TypingText
      className={textClass}
      cursor="|"
      onComplete={onDescTypingComplete}
      showCursor={!showBears}
      speed={12}
      startOnView={false}
      text="Nearly instant image editing & creation from your favorite models, straight from your favorite messenger apps."
    />
  );

  return <div className="w-full max-w-[30rem]">{descriptionContent}</div>;
}
